import { Tooltip } from "antd"
import React, { FC, ReactNode } from "react"
import styles from './EmissionCalculationError.module.scss'

export interface EmissionCalculationErrorProps {
  showError: boolean,
  children: ReactNode
}

const EmissionCalculationError: FC<EmissionCalculationErrorProps> = (props) => {

  const { showError, children } = props

  const reportLink = 'https://docs.google.com/forms/d/e/1FAIpQLSc6npdT7jNnRHKhNPAY4ZTjy4uahDMaGko8rTB9oT49k_n68A/viewform?usp=sf_link'

  const errorMessage = <div className={styles.tooltipContent}>
    Sorry an error has occured in the calculations for this portion of your product footprint. Please check the data you entered and resubmit. You can find the help desk instructions for this field located on the right hand side of your screen. If the error persists please report an error using the link <a href={reportLink} target="_blank"> HERE </a> or reach out to the CarbonOne team at developer@carbon-one.ca
  </div>

  return (
    <>
      {
        showError
          ? <Tooltip title={errorMessage} color={"#fff"}
            overlayClassName={styles.overlayTooltip}
          > {children} </Tooltip>
          : children
      }
    </>
  )
}

export default EmissionCalculationError